"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsMenu = void 0;
const React = require("react");
const react_1 = require("react");
const SalesOrderContext_1 = require("../../../contexts/SalesOrderContext");
const ProductsContext_1 = require("../../../contexts/ProductsContext");
const GroupHeading_1 = require("../../../../../../components/base/atoms/GroupHeading");
const ProductCard_1 = require("../../../atoms/ProductCard");
const TProductType_1 = require("../../../types/TProductType");
const SalesOrderItemFixed_1 = require("../../../models/SalesOrderItemFixed");
const SalesOrderItemBuilt_1 = require("../../../models/SalesOrderItemBuilt");
const ProductBuilderModal_1 = require("../../../modals/ProductBuilderModal");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ProductsMenu");
const ProductsMenu = ({ categories }) => {
    const [salesOrderItemBuilt, setSalesOrderItemBuilt] = (0, react_1.useState)(null);
    const builderPromise = (0, react_1.useRef)();
    const { products } = (0, react_1.useContext)(ProductsContext_1.ProductsContext);
    const { addSalesOrderItemToSalesOrder, isUpdatingCart, salesOrderItems } = (0, react_1.useContext)(SalesOrderContext_1.SalesOrderContext);
    const addProduct = (0, react_1.useCallback)(async (product) => {
        // directly add stocked product
        if (product.type === TProductType_1.TProductType.StockedProduct) {
            const newSalesOrderItem = new SalesOrderItemFixed_1.SalesOrderItemFixed(product);
            await addSalesOrderItemToSalesOrder(newSalesOrderItem);
            return new Promise(resolve => {
                setTimeout(() => resolve(true), 100);
            });
        }
        // allow product blueprint to be customised
        const newSalesOrderItemBuilt = new SalesOrderItemBuilt_1.SalesOrderItemBuilt(product);
        newSalesOrderItemBuilt.initialise();
        setSalesOrderItemBuilt(newSalesOrderItemBuilt);
        return new Promise((resolve, reject) => {
            builderPromise.current = { resolve, reject };
        });
    }, [addSalesOrderItemToSalesOrder]);
    const onBuildProductCompletion = (0, react_1.useCallback)(salesOrderItem => {
        if (salesOrderItem) {
            addSalesOrderItemToSalesOrder(salesOrderItem)
                .then(() => builderPromise.current.resolve(true))
                .catch(() => builderPromise.current.reject(false));
        }
        else {
            builderPromise.current.resolve(false);
        }
        setSalesOrderItemBuilt(null);
    }, [builderPromise, setSalesOrderItemBuilt, addSalesOrderItemToSalesOrder]);
    return (React.createElement("div", { className: css("") },
        categories.map(category => (React.createElement("div", { className: css("group"), id: category.name, key: category.name },
            React.createElement(GroupHeading_1.GroupHeading, null, category.label),
            React.createElement("div", { className: css("group_items") }, products
                .filter((product) => product.category.name === category.name)
                .map((product, index) => {
                return (React.createElement(ProductCard_1.ProductCard, { key: index, product: product, onClick: async () => !product.isOutOfStock && addProduct(product), isUpdatingCart: isUpdatingCart }));
            }))))),
        React.createElement(ProductBuilderModal_1.ProductBuilderModal, { salesOrderItemBuilt: salesOrderItemBuilt, onCompletion: onBuildProductCompletion })));
};
exports.ProductsMenu = ProductsMenu;
//# sourceMappingURL=index.js.map